import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {hideConfirm} from '../../store/slices/uiSlice';
import ActionDialog from '../shared/ActionDialog';

export default function ConfirmDialog(){
 const dispatch=useDispatch();
 const {show,message,confirmAction,payload,onConfirm}=useSelector(state=>state.ui.confirmDialog);
 const close=()=>dispatch(hideConfirm());
 const confirm=()=>{if(confirmAction)dispatch({type:confirmAction,payload});if(typeof onConfirm==='function')onConfirm();close();};
 return <ActionDialog open={!!show} title="Confirm action" danger size="sm" onClose={close} footer={<><button type="button" autoFocus className="sg-button" onClick={close}>Cancel</button><button type="button" className="sg-button sg-primary" onClick={confirm}>Yes, proceed</button></>}><p className="m-0 text-sm leading-7 text-slate-600">{message||'Are you sure you want to proceed?'}</p></ActionDialog>;
}
